import $ from "jquery";

const sqftCursorManager = {
  canvas: null,
  currentCursor: null,
  currentCursorOwner: null,
  noCursorStealing: false,

  init(canvas) {
    this.canvas = canvas;
    this.resetCursor(null);
  },

  setCursor(cursor, owner, noStealing = false) {
    this.noCursorStealing = noStealing || this.noCursorStealing;

    if (this.currentCursorOwner === null || this.currentCursorOwner === owner) {
      if (this.currentCursor !== cursor && this.canvas) {
        const prefix = "cursor-";
        const classes = this.canvas.className.split(" ").filter(c => c.lastIndexOf(prefix, 0) !== 0);
        this.canvas.className = classes.join(" ").trim();
        $(this.canvas).addClass(`cursor-${cursor}`);
        $(this.canvas).css({ cursor: null });
        this.currentCursorOwner = owner;
        this.currentCursor = cursor;
      }
    }
  },

  setCursorImage(cursorImage, owner, noStealing = false) {
    this.setCursor("image", owner, noStealing);
    $(this.canvas).css({ cursor: `url(${cursorImage}), default !important` });
  },

  resetCursor(owner) {
    if (this.currentCursorOwner === owner) {
      this.currentCursorOwner = null;
      this.setCursor("grab", null);
      this.releaseStealLock(owner);
    }
  },

  getCursor() {
    const prefix = "cursor-";
    const classes = this.canvas.className.split(" ").filter(c => c.lastIndexOf(prefix, 0) === 0);
    return classes.map(c => c.replace(prefix, ""));
  },

  stealCursor(override = false, revertBackAfterMouseUp = false) {
    if (override && this.currentCursorOwner) {
      if (this.currentCursorOwner.destroy) {
        this.currentCursorOwner.destroy(true, revertBackAfterMouseUp);
      }
    }

    if (!this.noCursorStealing || override) {
      this.resetCursor(this.currentCursorOwner);
    }
  },

  releaseStealLock(owner) {
    if (this.currentCursorOwner === owner) {
      this.noCursorStealing = false;
    }
  }
};

export default sqftCursorManager;
